import {delve} from "../util/util";

export const getSelectedAccount = (state) => delve(state, "productSelection.selectedAccount");
export const getCurrentProduct = (state) => delve(state, "productSelection.currentProduct");
export const getSelectedArticle = (state) => delve(state, "productSelection.selectedArticle");
export const getActivatedArticle = (state) => delve(state, "productSelection.activatedArticle");
export const isBaseArticleDataLoaded = (state) => delve(state, "productSelection.baseArticleDataLoaded");



/** WEBPACK FOOTER **
 ** ./src/selectors/ProductSelection.js
 **/